import type {FormDraftRecord} from "@/src/modules/core/lib/form-draft";
import {userPropertyService} from "@/src/modules/core/services/user-property";
import {useComplianceBusyStore} from "@/src/modules/core/store/compliance-busy";
import {useFormDraftResumeStore} from "@/src/modules/core/store/form-draft-resume";
import type {Property} from "@/src/modules/properties/types";

function resolveContextProperty(
  draft: FormDraftRecord,
  propertyById: Map<string, Property>,
): Property | null {
  if (draft.contextPropertyId != null) {
    return propertyById.get(String(draft.contextPropertyId)) ?? null;
  }

  const formProperty = draft.values.property;
  if (formProperty && typeof formProperty === "object" && "id" in formProperty) {
    return propertyById.get(String((formProperty as {id: number}).id)) ?? null;
  }

  return null;
}

/** Restore global property context and pending draft for cold-start / post-login resume. */
export function hydrateResumableFormDraft(
  draft: FormDraftRecord,
  meProperties: Property[],
): void {
  const propertyById = new Map(meProperties.map((property) => [String(property.id), property]));
  const contextProperty = resolveContextProperty(draft, propertyById);
  if (contextProperty) {
    userPropertyService.setUserProperty(contextProperty);
  }
  useFormDraftResumeStore.getState().setPending(draft);
  useComplianceBusyStore.getState().syncFormDraftDeferral();
}
